import type { ThemeComponentType } from '../types';

export const Drawer: ThemeComponentType = {
  styles: () => ({
    drawer: {
      display: 'grid',
      gridTemplateRows: 'auto 1fr auto',
    },
    header: {
      padding: '16px',
      display: 'grid',
      gridTemplateColumns: '1fr auto',
    },
    body: {
      padding: '16px',
      height: '100%',
      maxHeight: '100%',
      overflow: 'auto',
    },
  }),
};
